import axios from "axios";
import authHeader from "./auth-header";
import AuthService from "./auth.service";
import { config } from "../config";

class ReceptionAccessoryService {
  getAll() {
    return axios
      .get(`${config["apiUrl"]}reception-accessories`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status === 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        return Promise.reject(error);
      });
  }

  create(data) {
    return axios
      .post(`${config["apiUrl"]}reception-accessories`, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        return Promise.reject(error);
      });
  }

  update(id, data) {
    return axios
      .put(`${config["apiUrl"]}reception-accessories/${id}`, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        return Promise.reject(error);
      });
  }

  destroy(id) {
    return axios
      .delete(`${config["apiUrl"]}reception-accessories/${id}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        return Promise.reject(error);
      });
  }
}

export default new ReceptionAccessoryService();
